define('PDPSchema.Item.Model',
[
	'Item.Model',
	'Profile.Model',
	'SC.Configuration'
], 
function (
	ItemModel,
	ProfileModel,
	Configuration
) {
	'use strict';

	_.extend(ItemModel.prototype, {

        // @method containsMatrixChildItems
        // Returns true if the item contains sub matrix child items
        // @return {Boolean}
        containsMatrixChildItems: function () {
            return !! (this.get('_matrixChilds') && this.get('_matrixChilds').length);
        },

        // @method getJsonLdOffer
        // Returns the JSON-LD offer for an item
        // @return {Object}
        getJsonLdOffer: function getJsonLdOffer(itemUrl) {
            var stockInfo = this.getStockInfo();

            var offer = {
                '@type': 'Offer',
                availability: (stockInfo.isInStock) ? 'https://schema.org/InStock' : 'https://schema.org/OutOfStock',
                name: this.get('salesdescription'),
                mpn: this.get('mpn') || undefined,
                sku: this.getSku() || undefined,
                url: itemUrl || undefined
            };

            // Get price & currency
            var priceContainerObject = this.getPrice();
            var isPriceRange = priceContainerObject.min && priceContainerObject.max;
            if (!ProfileModel.getInstance().hidePrices()) {
                if (isPriceRange) {
                    offer.priceSpecification = {
                        '@type': 'PriceSpecification',
                        price: this.getPrice().price,
                        minPrice: priceContainerObject.min.price,
                        maxPrice: priceContainerObject.max.price
                    };
                } else {
                    offer.price = this.getPrice().price;
                }

                offer.priceCurrency = SC.getSessionInfo('currency') && SC.getSessionInfo('currency').code
                    ? SC.getSessionInfo('currency').code
                    : Configuration.get('siteSettings.shopperCurrency.code');
            }

            return offer;
        },

        // @method getStoreDescriptionAsText
        // Returns a text version of the item's web store description.  The HTML is removed, and multiple whitespace
        // characters are replaced with a single space.
        // @return {String}
        getStoreDescriptionAsText: function () {
            var htmlDescription = jQuery('<div/>').html(this.get('storedescription'));
            htmlDescription.find('script').remove();
            htmlDescription.find('style').remove();

            return htmlDescription.text().replace(/\s+/g, ' ').trim();
        }
        
    });
});
